import { createAsyncThunk } from '@reduxjs/toolkit'
import PaymentHistory from './payment-history-model'
import {
  delete_paymentHistory,
  load_paymentHistorys,
  store_paymentHistory,
} from './paymentHistory-service'

export const LoadPaymentHistorysAsync = createAsyncThunk<any, any>(
  'composer/load/paymentHistory',
  async (params: { uid: string }) => {
    return await load_paymentHistorys(params)
  },
)

export const CreatePaymentHistoryAsync = createAsyncThunk<any, any>(
  'composer/create/paymentHistory',
  async (params: PaymentHistory) => {
    return await store_paymentHistory(params)
  },
)

export const DeletePaymentHistoryAsync = createAsyncThunk<any, any>(
  'composer/delete/paymentHistory',
  async (params) => {
    return await delete_paymentHistory(params)
  },
)
